<template>
  <a-modal
    :title="$t('资料回收')"
    :visible="open"
    :confirm-loading="submitLoading"
    :width="920"
    :mask-closable="false"
    @cancel="handleCancel"
    @ok="submitForm"
  >
    <a-row :gutter="16" class="settle-upload-row">
      <a-col :span="6" v-for="item in uploadFields" :key="item.key">
        <div class="settle-upload-col">
          <div class="settle-upload-label">{{ $t(item.label) }}</div>
          <a-upload-dragger
            name="file"
            :show-upload-list="false"
            :disabled="uploading[item.key]"
            :before-upload="file => beforeUpload(file, item.key)"
          >
            <p class="ant-upload-drag-icon">
              <a-icon :type="uploading[item.key] ? 'loading' : 'folder-add'" />
            </p>
            <p class="ant-upload-text">{{ $t('将文件拖到此处，或') }} <span class="upload-link">{{ $t('点击上传') }}</span></p>
            <p
              v-if="form[item.key] && form[item.key].fileName"
              class="settle-upload-file-name"
              @click="downloadFile(item.key)"
            >
              {{ form[item.key].fileName }}
            </p>
          </a-upload-dragger>
          <div v-if="form[item.key]" class="settle-upload-actions">
            <a-button
              size="small"
              type="link"
              @click="downloadFile(item.key)"
            >
              <a-icon type="download" />{{ $t('下载') }}
            </a-button>
            <a-button
              size="small"
              type="link"
              @click="removeFile(item.key)"
            >{{ $t('删除') }}</a-button>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import { getSchoolBatchChangeLog, uploadSchoolBatchChangeLogSettle } from '@/api/school/schoolBatchChangeLog'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  name: 'SettleUploadForm',
  data () {
    return {
      open: false,
      submitLoading: false,
      form: {
        id: null,
        acceptanceFile: null,
        signFile: null,
        satisfactionFile: null,
        otherFile: null
      },
      uploading: {
        acceptanceFile: false,
        signFile: false,
        satisfactionFile: false,
        otherFile: false
      },
      uploadFields: [
        { key: 'acceptanceFile', label: '验收单' },
        { key: 'signFile', label: '签收单' },
        { key: 'satisfactionFile', label: '满意度调查' },
        { key: 'otherFile', label: '其他文件' }
      ]
    }
  },
  methods: {
    handleOpen (id) {
      this.resetForm()
      this.form.id = id
      this.open = true
      getSchoolBatchChangeLog({ id }).then(res => {
        const data = res.data || {}
        this.form.acceptanceFile = this.parseFileField(data.acceptanceFile)
        this.form.signFile = this.parseFileField(data.signFile)
        this.form.satisfactionFile = this.parseFileField(data.satisfactionFile)
        this.form.otherFile = this.parseFileField(data.otherFile)
      })
    },
    parseFileField (value) {
      if (!value) return null
      if (typeof value === 'object') return value.filePath ? value : null
      try {
        const obj = JSON.parse(value)
        return obj && obj.filePath ? obj : null
      } catch (e) {
        return { fileName: value.split('/').pop(), filePath: value }
      }
    },
    resetForm () {
      this.form = {
        id: null,
        acceptanceFile: null,
        signFile: null,
        satisfactionFile: null,
        otherFile: null
      }
      this.uploading = {
        acceptanceFile: false,
        signFile: false,
        satisfactionFile: false,
        otherFile: false
      }
    },
    beforeUpload (file, fieldKey) {
      this.doUpload(file, fieldKey)
      return false
    },
    async doUpload (file, fieldKey) {
      if (file.size / 1024 / 1024 > 20) {
        this.$message.error(this.$t('上传文件大小不能超过 20 MB'))
        return
      }
      this.uploading[fieldKey] = true
      const suffix = file.name.substring(file.name.lastIndexOf('.'))
      const path = generateFilePath('school', suffix)
      try {
        const url = await uploadObject(path, file)
        this.form[fieldKey] = { fileName: file.name, filePath: url }
        this.$message.success(this.$t('上传成功'))
      } catch (e) {
        this.$message.error(this.$t('上传失败'))
      } finally {
        this.uploading[fieldKey] = false
      }
    },
    removeFile (fieldKey) {
      this.form[fieldKey] = null
    },
    downloadFile (fieldKey) {
      const file = this.form[fieldKey]
      if (!file || !file.filePath) return
      const link = document.createElement('a')
      link.href = file.filePath
      link.download = file.fileName || file.filePath.split('/').pop().split('?')[0] || 'download'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    handleCancel () {
      this.open = false
      this.resetForm()
    },
    submitForm () {
      if (!this.form.id) return
      this.submitLoading = true
      uploadSchoolBatchChangeLogSettle({
        id: this.form.id,
        acceptanceFile: this.form.acceptanceFile,
        signFile: this.form.signFile,
        satisfactionFile: this.form.satisfactionFile,
        otherFile: this.form.otherFile
      }).then(() => {
        this.$message.success(this.$t('保存成功'))
        this.open = false
        this.$emit('ok')
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style scoped>
.settle-upload-row {
  margin-top: 8px;
}
.settle-upload-col {
  text-align: center;
}
.settle-upload-label {
  font-weight: 500;
  margin-bottom: 8px;
}
.settle-upload-file-name {
  color: #1890ff;
  margin: 0 8px;
  word-break: break-all;
  cursor: pointer;
}
.settle-upload-file-name:hover {
  text-decoration: underline;
}
.settle-upload-actions {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.upload-link {
  color: #1890ff;
}
</style>
